import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import { useYbug } from "@homesusa/core";
import { AppProvider, AppType, ThemeProvider } from "@homesusa/layout";
import { BrandFonts } from "../../../brand-fonts.component";
import AppRoutes from "./routes.component";

export function App(): JSX.Element {
  useYbug();

  return (
    <BrowserRouter>
      <ThemeProvider>
        <BrandFonts />
        <AppProvider appType={AppType.UserManagement}>
          <Suspense fallback={<LinearProgress />}>
            <AppRoutes />
          </Suspense>
        </AppProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
